import { Suspense, lazy } from 'react';
import { RouteObject } from 'react-router';

import BaseLayout from 'src/layouts/BaseLayout';
import SidebarLayout from 'src/layouts/SidebarLayout';

import SuspenseLoader from 'src/components/SuspenseLoader';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

// Pages

const Overview = Loader(lazy(() => import('src/content/overview')));

const ImpersonationPage = Loader(
  lazy(() => import('src/content/pages/Impersonation'))
);

const DecisioningPage = Loader(
  lazy(() => import('src/content/pages/Decisioning'))
);

const CustomerUpdate = Loader(
  lazy(() => import('src/content/pages/CustomerUpdate'))
);

const PrequalPage = Loader(
  lazy(() => import('src/content/pages/Prequal'))
);

const LenderSubmissionPage = Loader(
  lazy(() => import('src/content/pages/LenderSubmission'))
);

const CreditToolsPage = Loader(
  lazy(() => import('src/content/pages/CreditTools'))
);

const routes: RouteObject[] = [
  {
    path: '',
    element: <BaseLayout />,
    children: [
      {
        path: '/',
        element: <Overview />
      }
    ]
  },
  {
    path: 'impersonation',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <ImpersonationPage />
      }
    ]
  },
  {
    path: 'decisioning',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <DecisioningPage />
      }
    ]
  },
  {
    path: 'prequal',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <PrequalPage />
      }
    ]
  },
  {
    path: 'customer-update',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <CustomerUpdate />
      }
    ]
  },
  {
    path: 'lender-submission',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <LenderSubmissionPage />
      }
    ]
  },
  {
    path: 'credit-tools',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <CreditToolsPage />
      }
    ]
  }
];

export default routes;
